import React from 'react';

import { Box } from '@mantine/core';

import { setReplacedPersonId } from '@/store/user-process/user-process';
import { selectReplacedPersonId } from '@/store/user-process/user-selectors';

import useAppStore from '@/shared/store/app.store';
import useUserStore from '@/shared/store/user.store.ts';

import { UserSearch } from './UserSearch';
import { useAppDispatch, useAppSelector } from '@/hooks';

export const UserReplace: React.FC = () => {
	const isMobile = useAppStore((state) => state.isMobile);

	const replacedPersonId = useAppSelector(selectReplacedPersonId);
	const setTargetPersonId = useUserStore((state) => state.setTargetPersonId);

	const dispatch = useAppDispatch();

	return (
		<Box {...(!isMobile && { w: 300 })}>
			<UserSearch
				label="Текущий пользователь"
				initialValue={replacedPersonId ?? undefined}
				setPersonId={(personId) => {
					dispatch(setReplacedPersonId(personId));
					setTargetPersonId(personId);
				}}
			/>
		</Box>
	);
};
